import BaseClient from './BaseClient';

class AdminTeamMigrationsClient extends BaseClient {
    listMigrations(params) {
        const url = `/api/admin/team-migrations`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    showMigration(migrationId) {
        const url = `/api/admin/team-migrations/${migrationId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createMigration(data) {
        const url = `/api/admin/team-migrations`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    showConfig(migrationId) {
        const url = `/api/admin/team-migrations/${migrationId}/config`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateConfig(migrationId, config) {
        const url = `/api/admin/team-migrations/${migrationId}/config`;
        return this.makeCoreApiRequest(url, 'put', config);
    }

    startMigration(migrationId) {
        const url = `/api/admin/team-migrations/${migrationId}/start`;
        return this.makeCoreApiRequest(url, 'post');
    }

    cancelMigration(migrationId) {
        const url = `/api/admin/team-migrations/${migrationId}/cancel`;
        return this.makeCoreApiRequest(url, 'post');
    }

    deleteMigration(migrationId) {
        const url = `/api/admin/team-migrations/${migrationId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}

export default new AdminTeamMigrationsClient();
